import { combineReducers } from 'redux';
import authReducer from '../auth/authReducer';
import uiReducer from '../ui/uiReducer'
import { apiSlice } from "../api/apiSlice";
import loadingStateReducer from '../ui/loadingStateReducer'
import multiselectApiOptionsReducer from '../ui/multiselectApiOptionsReducer';

export default combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  auth: authReducer,
  ui: uiReducer,
  loadingState: loadingStateReducer,
  multiselectApiOptions: multiselectApiOptionsReducer
})
